import { Component, OnInit,Input ,Output,EventEmitter} from '@angular/core';
import { CommonapiService } from '../../../Service/Commonapi.service';
import { CustomerapiService } from '../../../Service/Customerapi.service';

@Component({
  selector: 'app-CTVerify',
  templateUrl: './CTVerify.component.html'
})
export class CTVerifyComponent implements OnInit {
  @Output() CallParent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  constructor(private Winfoapi: CommonapiService, private custapi: CustomerapiService) { }
  show_verify=false;
  ngOnInit() {
    //console.log(this.data);
  }
  varify_cancel() {
    this.show_verify = false;
  }
  state: any = {
    comments: { value: "", iserr: false, err_txt: "" },
    verifylistval: { value: 0, iserr: false, err_txt: "" },
    VerifyList: [
      { id: 1, name: "Verify" }, { id: 2, name: "Duplicate" }, { id: 3, name: "Reject" }
    ]
  }
  varify_check() {
    let isvalid = true;
    if (this.state.verifylistval.value == 0) {
      this.state.verifylistval.iserr = true;
      this.state.verifylistval.err_txt = "Select Verify options";
      isvalid = false;
    }
    
    if (isvalid) {
      var postdata = {
        "CustomerId": this.data.customer_id+"", "isVerified": this.state.verifylistval.value.id+"",
        comments: this.state.comments.value
      }
      console.log('postdata', postdata)
      //return false;
      this.Winfoapi.loader.startLoading();
      this.custapi.SetCustomerVerified(postdata, false).then(sdata => {
        console.log("data", sdata)
        if (sdata.status == 1 && this.state.verifylistval.value.id == 1) {          
          this.data.is_verified = true;
          this.Winfoapi.Toast_success(" \""+ this.data.customer_name +  "\" is Verified  ",true);          
        }
        this.show_verify = false;
        this.Winfoapi.loader.stopLoading();
      });
    }
  }
  CallVerified(obj) {
    console.log(obj);
    this.state.verifylistval.value = 0;
    this.show_verify = true; 
    this.state.comments.value = "";
    this.state.verifylistval.iserr = false
    this.state.verifylistval.err_txt = "";
  }
  Callparentfunc(){
    this.CallParent.emit();
  }
}
